// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CertificateGenerator from "./CertificateGenerator";
import SearchPage from "./SearchPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SearchPage />} />
        <Route path="/generate" element={<CertificateGenerator />} />
      </Routes>
    </Router>
  );
}

export default App;
